import { FormValues } from "./types";

export const DEFAULT_VALUES: FormValues = {
  cash: {},
  balance: {
    cash: 0,
    creditcard: 0,
    debitcard: 0
  }
}